import { useMemo } from "react";

import type { Permission, PersonnelTmdPermission } from "src/api/Tmd.dtos";
import hasPermission from "src/utilities/hasPermission";

/**
 * Memoizes the contextual client permission decision for the supplied grants and owner IDs.
 *
 * Assumptions: Grant changes replace the array reference to invalidate the memo.
 *
 * Postconditions: Returns the shared helper's UI decision without making an authorization
 * request.
 */
const useHasPermission = (
    personnelTmdPermissions: PersonnelTmdPermission[],
    permission: Permission,
    trialId?: number,
    institutionId?: number
): boolean => {
    return useMemo(
        () => {
            return hasPermission(personnelTmdPermissions, permission, trialId, institutionId);
        },
        [personnelTmdPermissions, permission, trialId, institutionId]
    );
};

export default useHasPermission;
